import { gql, useQuery } from '@apollo/client';

const FEATURE_FLAG = gql`
  query FeatureFlag($key: String!) {
    featureFlag(key: $key) {
      key
      enabled
      launchAt
    }
  }
`;

export function useFeatureFlag(key: string) {
  const { data, loading } = useQuery(FEATURE_FLAG, {
    variables: { key },
  });

  const flag = data?.featureFlag;

  return {
    enabled: Boolean(flag?.enabled),
    launchAt: flag?.launchAt ? new Date(flag.launchAt) : null,
    loading,
  };
}
